import { render, staticRenderFns } from "./PickModule.vue?vue&type=template&id=67e9c067&"
import script from "./PickModule.vue?vue&type=script&lang=js&"
export * from "./PickModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports